import PageContainer from '@/common/components/PageContainer'
import EditDynamicSectionListing from '@/modules/client-setting/components/EditDynamicSection/components/EditDynamicSectionListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function EditDynamicSectionPage() {
	return (
		<PageContainer>
			<EditDynamicSectionListing />
		</PageContainer>
	)
}

const GuardedEditDynamicSectionPage = withUserPermission(
	EditDynamicSectionPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.WEB_SETTING],
	},
)

export default GuardedEditDynamicSectionPage
